(function referenceDataSourceInitLambda(global) {

  // Источник данных для грида.
  var ReferenceDataSource = WA.CMP.dataViews.BaseDataProvider.extend({
    referenceName: '',
    referenceView: '',
    initialState: null,

    _cacheID: '',
    _saveSateTimeout: null,

    init: function (referenceName, referenceView, placementContext, initialState) {
      var me = this;

      me._super(initialState);

      me.referenceName = referenceName;
      me.referenceView = referenceView;
      me.placementContext = placementContext;
      me.initialState = initialState;

      me._cacheID = generateUniqueID();

      me.defaults = {
        ReferenceName: me.referenceName,
        ReferenceView: me.referenceView,
        PlacementContext: me.placementContext
      }
    },

    makeParams: function (loadOptions) {
      var me = this;
      loadOptions.CacheID = me._cacheID;
      return {
        Params: $.toJSON(me.extendDefaults(loadOptions))
      }
    },

    /**
     * Загрузить список записей.
     *
     * @method load
     * @param {Object} loadOptions Опции загрузки.
     * @return {Deferred<Object>} Загруженные записи.
     * @see https://api.jquery.com/category/deferred-object/
     */
    load: function (loadOptions) {
      var me = this;
      var result = new $.Deferred();
      var rowsQuery = WA.SRV.call('/Reference.asmx/GetGridRows', me.makeParams(loadOptions));

      // Запрос получения данных уже и так сохраняет состояние в профиле, поэтому предотвращаем отдельные лишние запросы для сохранения состояния.
      clearTimeout(me._saveSateTimeout);

      rowsQuery.done(function onDataLoad(data) {
        result.resolve($.parseJSON(data));
      }).fail(function onDataFail(err) {
        log.error("GRID", "Can not get data for table. " + err);        
        result.reject("Can not get data for table. " + err);
      });

      return result.promise();
    },

    totalCount: function (filter, globalLikeFilter) {
      var me = this;
      return WA.SRV.call("/Reference.asmx/GetRecordCount", {
        ReferenceCode: me.referenceName,
        ReferenceView: me.referenceView,
        SelectExpression: filter ? filter : "",        
        IgnoreRestrictions: true,
        PlacementContext: me.placementContext,
        QueryInstanceID: me.initialState.QueryInstanceID,
        QueryContext: me.initialState.QueryContext,
        GlobalLikeFilter: globalLikeFilter ? globalLikeFilter : ""
      }).promise();
    },

    /**
     * Загрузить состояние.
     *
     * @method loadState
     * @return {Deferred<Object>} Состояние.
     * @see https://api.jquery.com/category/deferred-object/
     */
    loadState: function () {
      var me = this;
      var result = $.Deferred();
      result.resolve(me.initialState);
      return result.promise();
    },

    /**
     * Сохранить состояние.
     *
     * @method saveState
     * @param {Object} loadOptions Опции загрузки.
     * @param {boolean} forceSaveToServer Признак принудительного сохранения на сервере.
     * @return {Deferred<void>}
     * @see https://api.jquery.com/category/deferred-object/
     */
    saveState: function (loadOptions, forceSaveToServer) {
      var me = this;
      var result = $.Deferred();
      if (forceSaveToServer !== true) {
        // Сохранение состояния теперь при получении данных.
        result.resolve();
      } else {
        clearTimeout(me._saveSateTimeout);
        me._saveSateTimeout = setTimeout(function () {
          WA.SRV.call('/Reference.asmx/SaveGridState', me.makeParams(loadOptions)).promise().done(function () {
            result.resolve();
          }).fail(function () {
            result.reject();
          });
        }, 200);
      }
      return result.promise();
    }
  });


  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  // Публичные объекты.
  global.ReferenceDataSource = ReferenceDataSource;
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

})(window.Core.grid);